var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-input',{staticClass:"w-input-time",attrs:{"time":"","refs":"input","label":_vm.label,"fancy":_vm.fancy,"has-error":_vm.hasError,"step":_vm.step},on:{"blur":function($event){return _vm.onBlur($event)}},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }